import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import {
  injectInjectables,
  registerGlobalComponents,
  isDevEnv,
  injectFilters,
} from "@/utils";
import "@/plugins/dayjs.js";
import "@/utils/date.utils";
import "./registerServiceWorker";

Vue.config.productionTip = false;

/**
 * Enables vue devtools in development enviroment
 */
Vue.config.devtools = isDevEnv();

/**
 * Injects injectables in the vue globally
 */
injectInjectables();

injectFilters();

registerGlobalComponents();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
